"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectFormContextProvider = void 0;
var React = require("react");
var urls_1 = require("../../urls");
var utils_1 = require("../../utils");
var initialState = {
    isLoading: false,
    formFields: {},
    formErrors: {},
};
var ProjectFormContext = React.createContext(__assign(__assign({}, initialState), { fetchProjectInformation: undefined, onFormSubmit: undefined }));
exports.default = ProjectFormContext;
var ProjectFormContextProvider = (function (_super) {
    __extends(ProjectFormContextProvider, _super);
    function ProjectFormContextProvider(props) {
        var _this = _super.call(this, props) || this;
        _this.state = __assign({}, initialState);
        return _this;
    }
    ProjectFormContextProvider.prototype.fetchProjectInformation = function () {
        return __awaiter(this, void 0, void 0, function () {
            var removeLogo;
            var _this = this;
            return __generator(this, function (_a) {
                this.setState({ isLoading: true });
                removeLogo = this.removeProjectLogo.bind(this);
                return [2, $.ajax((0, urls_1.resolve)(urls_1.Urls.admin_project_info, this.props.project_id), {
                        type: "GET",
                        complete: ajaxErrorHandler,
                        success: function (result) {
                            var fields = result.formFields;
                            fields["project_logo"].removeFile = removeLogo;
                            _this.setState({
                                isLoading: false,
                                formFields: fields,
                            });
                        }
                    })];
            });
        });
    };
    ProjectFormContextProvider.prototype.removeProjectLogo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var self;
            return __generator(this, function (_a) {
                self = this;
                return [2, $.ajax((0, urls_1.resolve)(urls_1.Urls.remove_project_logo, this.props.project_id), {
                        type: "GET",
                        complete: ajaxErrorHandler,
                        success: function (result) {
                            if (result.success)
                                self.fetchProjectInformation();
                        }
                    })];
            });
        });
    };
    ProjectFormContextProvider.prototype.onFormSubmit = function (e) {
        return __awaiter(this, void 0, void 0, function () {
            var formData;
            var _this = this;
            return __generator(this, function (_a) {
                (0, utils_1.preventDefault)(e);
                formData = new FormData(e.currentTarget);
                return [2, $.ajax((0, urls_1.resolve)(urls_1.Urls.admin_project_info, this.props.project_id), {
                        type: "POST",
                        processData: false,
                        contentType: false,
                        data: formData,
                        complete: ajaxErrorHandler,
                        success: function (response) {
                            if (response.success)
                                _this.fetchProjectInformation();
                            else if (response.errors)
                                _this.setState({
                                    formErrors: response.errors
                                });
                        }
                    })];
            });
        });
    };
    ProjectFormContextProvider.prototype.render = function () {
        var self = this;
        return (React.createElement(ProjectFormContext.Provider, { value: __assign(__assign({}, self.state), { fetchProjectInformation: self.fetchProjectInformation.bind(self), onFormSubmit: self.onFormSubmit.bind(self) }) }, this.props.children));
    };
    return ProjectFormContextProvider;
}(React.Component));
exports.ProjectFormContextProvider = ProjectFormContextProvider;
